import { zergApi } from "@/service/zerg";

const prefix = "setting/empresa";

class EmpresaService {

    async index(params) {
        try {
            const data = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async show(params) {
        try {
            const data = await zergApi.post(`${prefix}/show`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async store(params) {
        try {
            const data = await zergApi.post(`${prefix}/store`, params, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async update(params) {
        try {
            const data = await zergApi.post(`${prefix}/update`, params, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }); return data;
        } catch (error) {
            throw error;
        }
    }

    async cuentasBancarias() {
        try {
            const data = await zergApi.post(`${prefix}/cuentas-bancarias`);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new EmpresaService();